module.exports = __webpack_public_path__ + "static/media/KV_073641.d58ec419.jpg";